/** Déclaration Trimestrielle des Salaires (CNSS Gabon). */

export const TRIMESTRE_RE = /^(\d{4})-T([1-4])$/;

export type StatutDts = 'brouillon' | 'deposee' | 'annulee';

export interface DtsLigne {
  salarie_id: string;
  matricule: string;
  nom_complet: string;
  numero_cnss: string;
  brut: number;
  base_cnss: number;
  patronale: number;
  salariale: number;
  mois_presents: number;
  /**
   * Ventilation de la CNSS patronale (communiqué CNSS du 12/01/2026) : prestations familiales 5 %, AT-MP 2 %, VID 11 %.
   * Absente d'une ligne enregistrée avant cette décision : elle est alors reconstituée à l'affichage (voir `ventilationLigneDts`).
   */
  patronale_pf?: number;
  patronale_atmp?: number;
  patronale_vid?: number;
}

export interface DeclarationDts {
  readonly id: string;
  tenant_id: string;
  trimestre: string;
  periodes: string[];
  statut: StatutDts;
  lignes: DtsLigne[];
  total_brut: number;
  total_base_cnss: number;
  total_patronale: number;
  total_salariale: number;
  effectif: number;
  notes?: string;
  reference_depot?: string;
  date_depot?: string;
  cree_le: string;
  maj_le: string;
}
